import React from "react";
import { observer } from "mobx-react";
import { Switch, Route, withRouter } from "react-router-dom";
import { useMessageGetter } from "react-message-context";
import ScrollToTop from "./components/ScrollToTop";
import "./App.scss";
import FormPage from "./components/pages/FormPage";
import ThanksPage from "./components/pages/ThanksPage";
import QuitPage from "./components/pages/QuitPage";
import ErrorPage from "./components/pages/ErrorPage";
import ErrorBoundary from "./components/ErrorBoundary";
import { LocaleProvider } from "@op/opds.opux";

const App = observer(() => {
  const msgs = useMessageGetter("url");
  const { lang } = window.ROF_PARAMS;
  return (
    <div className="rof">
      <ErrorBoundary>
        <LocaleProvider locale={lang}>
          <ScrollToTop />
          <Switch>
            <Route exact path={`${msgs("quit")}`}>
              <QuitPage />
            </Route>
            <Route exact path={`${msgs("error")}`}>
              <ErrorPage />
            </Route>
            <Route exact path={`${msgs("thanks")}`}>
              <ThanksPage />
            </Route>
            <Route>
              <FormPage />
            </Route>
          </Switch>
        </LocaleProvider>
      </ErrorBoundary>
    </div>
  );
});

export default withRouter(App);
